import { render, staticRenderFns } from "./ObjLinkValueInput.vue?vue&type=template&id=87345bb6&"
import script from "./ObjLinkValueInput.vue?vue&type=script&lang=js&"
export * from "./ObjLinkValueInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports